import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from 'src/app/utils/utils.service';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-time-menu',
  templateUrl: './time-menu.component.html',
  styleUrls: ['./time-menu.component.scss']
})
export class TimeMenuComponent implements OnInit {

  is24Active;
  iscurrentActive;
  is10Active;
  isWeeklyActive;
  ismonthlyActive;
  forecastLengthSubscription: any;
  forecastLength: any;
  moduleName: string;
  componentName : string;
  forecastSubscription: any;
  @Input() sourceSelected: any;
  @Input() activeSideMenu: any;
  notDesktop: boolean;
  adminSelected = true;
  ruralSelected: boolean = true;
  lang: string;
  engSelected: boolean = true;
  stateUrlId: string;

  constructor(private utils: UtilsService, private router: Router, private http: HttpClient, private route: ActivatedRoute,) {
    this.is24Active = true;
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    this.forecastSubscription = this.route.params.subscribe(routeParams => {
      const forecastLength = routeParams.time;
      if (forecastLength != this.forecastLength) {
        this.forecastLength = routeParams.time;
        this.utils.setForecastLengthChanged(this.forecastLength);
        switch (this.forecastLength) {
          case 'current' : this.iscurrentActive = true; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = false;
                           break;

          case '24' : this.iscurrentActive = false; this.is24Active = true; this.is10Active = false; this.ismonthlyActive = false;
                      this.isWeeklyActive = false; break;

          case '10' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = true; this.ismonthlyActive = false;
                      this.isWeeklyActive = false; break;

          case 'monthly' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = true;
                      this.isWeeklyActive = false ; break

          case 'weekly' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = false;
                      this.isWeeklyActive = true; break;
      }
      }
    });
   }

  ngOnChanges(changes: SimpleChanges){
    // if(changes.sourceSelected.previousValue=='ECMWF' && changes.sourceSelected.currentValue=='IMD'){
    //   this.routeChange('24');
    // }
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

  ruralUrbanToggle() {
    this.ruralSelected = !this.ruralSelected;
    this.utils.setRuralUrbanToggle(this.ruralSelected);
  }

  engTeluguToggle() {
    this.engSelected = !this.engSelected;
  }

  ngOnInit() {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');
    
    this.utils.getAdminBasinToggle().subscribe(bool => {
      this.adminSelected = bool;
    })
    this.utils.getRuralUrbanToggle().subscribe(value => {
      if(this.ruralSelected!=value) {
        this.ruralSelected = value;
      }
    })
    this.moduleName = this.router.url.split('/')[1];
    this.componentName = this.router.url.split('/')[2];
    // console.log(this.moduleName);
    this.forecastLengthSubscription = this.utils.getForecastLengthChanged().subscribe(value => {
      if (value == null) {
        this.forecastLength = this.router.url.split('/')[3];
      } else {
        this.forecastLength = value;
      }
      switch (this.forecastLength) {
        case 'current' : this.iscurrentActive = true; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = false;
                         break;

        case '24' : this.iscurrentActive = false; this.is24Active = true; this.is10Active = false; this.ismonthlyActive = false;
                      this.isWeeklyActive = false; break;

        case '10' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = true; this.ismonthlyActive = false;
                      this.isWeeklyActive = false; break;

        case 'monthly' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = true;
                      this.isWeeklyActive = false ; break

          case 'weekly' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = false;
                      this.isWeeklyActive = true; break;
    }
    });

    if(this.utils.getDeviceType()!="desktop"){
      this.notDesktop = true;
      // this.routeChange('24');
    }
  }
  routeChange(time) {
    // call utils service to call route changed
    this.utils.setForecastLengthChanged(time);
    const moduleName = this.router.url.split('/')[1];
    const componentName = this.router.url.split('/')[2];
    const stateId = this.router.url.split('/')[4];
    this.router.navigate([moduleName, componentName, time, stateId]);
    switch (time) {
        case 'current' : this.iscurrentActive = true; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = false;
                         break;

        case '24' : this.iscurrentActive = false; this.is24Active = true; this.is10Active = false; this.ismonthlyActive = false;
                  this.isWeeklyActive = false; break;

        case '10' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = true; this.ismonthlyActive = false;
                  this.isWeeklyActive = false; break;

        case 'monthly' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = true;
                  this.isWeeklyActive = false ; break

      case 'weekly' : this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.ismonthlyActive = false;
                  this.isWeeklyActive = true; break;
    }
  }

}
